import log from "loglevel";
export function installVideoHighspeed() {
    $(document).keyup(function (e) {
        if (e.key === "s") {
            log.info("video play cheat");
            $("video").prop("playbackRate", 10);
        }
    });
}
export function installVideoSpeedReset() {
    $(document).keyup(function (e) {
        if (e.key === "d") {
            log.info("video play cheat reset");
            $("video").prop("playbackRate", 1);
        }
    });
}
//# sourceMappingURL=videoCheater.js.map